// hooks/useIngredientsForm.js
import { useState, useCallback, useMemo } from 'react';
import {  useFormErrors } from '../../../utils/utils';

/*export const useIngredientsForm = (initialIngredients = [], ingredientsLib = [], handleAddIngredient) => {
    const normalizedIngredients = useMemo(() => {
      console.log(initialIngredients)
    return initialIngredients.map(ing => ({
      _id: ing.ingredient?._id || ing._id,
      name: ing.ingredient?.nameRu || ing.ingredient?.name || ing.name || '',
      measure: ing.measure || '',
      weight: ing.weight || 0,
      totalWeight: ing.totalWeight || 0,
      group: ing.group || 'Основное блюдо',
      note: ing.note || 'fresh',
      // Сохраняем полный объект ингредиента для доступа к доп. полям
      fullIngredient: ing.ingredient || null
    }));
  }, [initialIngredients]);
   const {error, validate, setError} = useFormErrors()
  const [ingredientsData, setIngredientsData] = useState(normalizedIngredients); 
  const [selectedIngredient, setSelectedIngredient] = useState({
    _id: '',
    name: '',
    measure: '',
    weight: '',
    totalWeight: '',
    group: 'Основное блюдо',
    note: 'fresh',
    availableMeasures: [],
  });

  const [filteredIngredients, setFilteredIngredients] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [errors, setErrors] = useState({});
   const [isOpenProcess, setIsOpenProcess] = useState(false);
   const [isOpenMeasure, setIsOpenMeasure] = useState(false);
   const [isOpenGroup, setIsOpenGroup] = useState(false);
 
   function filtrSearchArr(arr, keyword) {
  const keywordSearch = keyword.toLowerCase();
  return arr.filter(item => item.name.toLowerCase().includes(keywordSearch));
}

  // Поиск ингредиентов
  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setSelectedIngredient(prev => ({ ...prev, name: value }));
    validate(name, value)
    setHidden(true);
    if (value) {
      setFilteredIngredients(filtrSearchArr(ingredientsLib, value));
    } else {
      setFilteredIngredients([]);
      setHidden(false)
    }
  };
 
  // Выбор ингредиента из списка
  const handleSelect = (ingredient) => {
    setSelectedIngredient({
      _id: ingredient._id,
      name: ingredient.nameRu || ingredient.name,
      measure: '',
      weight: '',
      group: ingredient.group || 'Основное блюдо',
      note: 'fresh',
      availableMeasures: ingredient.measure || []
    });
    setHidden(false);
    setFilteredIngredients([]);
    validate('name', ingredient.nameRu || ingredient.name);
  };

  // Изменение полей
  const handleChange = (e) => {
    const { name, value } = e.target;  
    validate(name, value)
    setSelectedIngredient(prev => ({ ...prev, [name]: value }));
    if(name === 'totalWeight') {
    if (!isNaN(Number(value)) && Number(value) >= 1 && Number(value) <= 1000) {
      setSelectedIngredient(prev => ({ ...prev, totalWeight: Number(value) }));
    } else if (value === '') {
      // Если поле пустое, разрешаем его очистить
      setSelectedIngredient(prev => ({ ...prev, totalWeight: 0 }));
    }
  }
}


   function handleFocusProcess () {
    setIsOpenProcess(!isOpenProcess)
  }  
  function handleFocusMeasure() {
    setIsOpenMeasure(!isOpenMeasure)
  } 
  
  function handleFocusGroup() {
    console.log('click')
    setIsOpenGroup(!isOpenGroup)
  } 
 
  // Добавление ингредиента
  const handleAdd = () => {
    if (!selectedIngredient._id || !selectedIngredient.totalWeight || !selectedIngredient.measure) {
      setErrors({
        ...errors,
        name: !selectedIngredient._id ? 'Выберите ингредиент' : undefined,
        weight: !selectedIngredient.totalWeight ? 'Введите вес' : undefined,
        measure: !selectedIngredient.measure ? 'Выберите единицу' : undefined
      });
      return;
    }
    
    setIngredientsData(prev => [...prev, { ...selectedIngredient }]);
    handleAddIngredient(selectedIngredient)

    // Сброс формы
    setSelectedIngredient({
      _id: '',
      name: '',
      measure: '',
      weight: '',
      group: 'Основное блюдо',
      note: 'fresh',
      availableMeasures: []
    });
    setFilteredIngredients([]);
    setErrors({});
  };

  // Удаление ингредиента
  function handleDelete(id, group) {
    setIngredientsData((cards) => 
      cards.filter((c) => !(c._id === id && c.group === group))
    );
  }

  // Редактирование веса 
  const handleWeightChange = (id, value, group, index) => { 
     validate(`weight${index}` , value, index)
    setIngredientsData(prev => 
      prev.map((c) => 
        (c._id === id && c.group === group) ? { ...c, totalWeight: value } : c
      )
    );
   };


  // Общее количество ингредиентов
  const totalIngredients = useMemo(() => ingredientsData.length, [ingredientsData]);
  
  // Валидность формы
  const isFormValid = useMemo(() => {
    return selectedIngredient._id && selectedIngredient.totalWeight > 0 && selectedIngredient.measure;
  }, [selectedIngredient]);

  return {
    // Данные
    ingredientsData,
    selectedIngredient,
    filteredIngredients,
    hidden,
    errors,
    totalIngredients,
    isFormValid,
    isOpenMeasure,
    isOpenGroup,
    isOpenProcess,
    
    // Действия
    handleInputChange,
    handleSelect,
    handleChange,
    handleAdd,
    handleDelete,
    handleWeightChange,
    setHidden,
    handleFocusMeasure,
    handleFocusGroup,
    handleFocusProcess,
    handleAddIngredient ,
  };
};*/

 

export const useIngredientsForm = (initialIngredients = [], ingredientsLib = [], onIngredientsChange) => {
  const { error, validate, setError } = useFormErrors();
  
  // 🔥 Нормализация данных из сервера в единый формат
  const normalizedIngredients = useMemo(() => {
    console.log('Нормализация начальных ингредиентов:', initialIngredients);
    
    return initialIngredients.map(ing => ({
      _id: ing._id || ing.ingredient?._id,
      ingredient: ing.ingredient?._id || ing._id, // ID для сервера
      name: ing.ingredient?.nameRu || ing.ingredient?.name || ing.name || '',
      weight: ing.weight || 0,  // вес на 1г порции
      totalWeight: ing.totalWeight || 0, //общий вес на все порции
      measure: ing.measure || '',
      group: ing.group || 'Основное блюдо',
      note: ing.note || 'fresh', 
    }));
  }, [initialIngredients]);

  const [ingredientsData, setIngredientsData] = useState(normalizedIngredients);
  const [selectedIngredient, setSelectedIngredient] = useState({
    _id: '',
    ingredient: '',  // ID для сервера
    name: '',
    measure: '',
    weight: '',
    totalWeight: '',
    group: 'Основное блюдо',
    note: 'fresh',
    availableMeasures: [],
  });
  console.log(ingredientsData, initialIngredients)
  const [filteredIngredients, setFilteredIngredients] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [errors, setErrors] = useState({});
  const [isOpenProcess, setIsOpenProcess] = useState(false);
  const [isOpenMeasure, setIsOpenMeasure] = useState(false);
  const [isOpenGroup, setIsOpenGroup] = useState(false);
console.log(selectedIngredient)
  // Поиск ингредиентов
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedIngredient(prev => ({ ...prev, name: value }));
    validate(name, value);
    setHidden(true);
    
    if (value) {
      const filtered = ingredientsLib.filter(item => 
        (item.nameRu || item.name).toLowerCase().includes(value.toLowerCase())
      );
      setFilteredIngredients(filtered);
    } else {
      setFilteredIngredients([]);
      setHidden(false);
    }
  };

  // Выбор ингредиента из списка
  const handleSelect = (ingredient) => {
    setSelectedIngredient({
      _id: ingredient._id,
      ingredient: ingredient._id,  // ID для сервера
      name: ingredient.nameRu || ingredient.name,
      measure: '',
      weight: '',
      totalWeight: '',
      group: 'Основное блюдо',
      note: 'fresh',
      availableMeasures: ingredient.measure || []
    });
    setHidden(false);
    setFilteredIngredients([]);
    validate('name', ingredient.nameRu || ingredient.name);
  };

  // Изменение полей
  const handleChange = (e) => {
    const { name, value } = e.target;
    validate(name, value);
    setSelectedIngredient(prev => ({ ...prev, [name]: value }));
    
    if (name === 'totalWeight') {
      if (!isNaN(Number(value)) && Number(value) >= 0 && Number(value) <= 1000) {
        setSelectedIngredient(prev => ({ ...prev, totalWeight: Number(value) }));
      } else if (value === '') {
        setSelectedIngredient(prev => ({ ...prev, totalWeight: 0 }));
      }
    }
  };

  // Добавление ингредиента
  const handleAdd = () => {
    if (!selectedIngredient.ingredient || !selectedIngredient.totalWeight || !selectedIngredient.measure) {
      setErrors({
        ingredient: !selectedIngredient.ingredient ? 'Выберите ингредиент' : undefined,
        weight: !selectedIngredient.totalWeight ? 'Введите вес' : undefined,
        measure: !selectedIngredient.measure ? 'Выберите единицу' : undefined
      });
      return;
    }
    
    // 🔥 Создаем ингредиент в формате для сервера
    const newIngredient = {
      ingredient: selectedIngredient.ingredient,  // только ID
      weight: selectedIngredient.weight,
      totalWeight: selectedIngredient.totalWeight,
      measure: selectedIngredient.measure,
      group: selectedIngredient.group,
      note: selectedIngredient.note,
      name: selectedIngredient.name,
    };
    
    const newIngredients = [...ingredientsData, newIngredient];
    setIngredientsData(newIngredients);
    onIngredientsChange(newIngredients); 
    
    // Сброс формы
    setSelectedIngredient({
      _id: '',
      ingredient: '',
      name: '',
      measure: '',
      weight: '',
      totalWeight: '',
      group: 'Основное блюдо',
      note: 'fresh',
      availableMeasures: []
    });
    setFilteredIngredients([]);
    setErrors({});
  };

  // Удаление ингредиента
  const handleDelete = (id, group) => { 
    const newIngredients = ingredientsData.filter((item) => !(item._id === id && item.group === group)); 
    setIngredientsData(newIngredients);
    if (onIngredientsChange) {
      onIngredientsChange(newIngredients);
    }
  };

  // Редактирование веса
  const handleWeightChange = (id, value, group, index) => {
    console.log(id, value, group, index)
    validate(`weight${index}`, value);
   
    setIngredientsData(prev => 
    prev.map(item => 
      (item._id === id && item.group === group) 
        ? { ...item, totalWeight: Number(value) || 0 } 
        : item
    )
  );
    if (onIngredientsChange) {
         const updatedIngredients = ingredientsData.map(item => 
      (item._id === id && item.group === group) 
        ? { ...item, totalWeight: Number(value) || 0 } 
        : item
    );
    onIngredientsChange(updatedIngredients);
    }
  };

  // 🔥 Получить данные для отправки на сервер
  const getIngredientsForServer = useCallback(() => {
    return ingredientsData.map(ing => ({
      ingredient: ing.ingredient,
      weight: ing.weight,
      totalWeight: ing.totalWeight,
      measure: ing.measure,
      group: ing.group,
      note: ing.note
    }));
  }, [ingredientsData]);

  const totalIngredients = useMemo(() => ingredientsData.length, [ingredientsData]);
  const isFormValid = useMemo(() => {
    return selectedIngredient.ingredient && selectedIngredient.totalWeight > 0 && selectedIngredient.measure;
  }, [selectedIngredient]);

  return {
    // Данные
    ingredientsData,
    selectedIngredient,
    filteredIngredients,
    hidden,
    errors,
    totalIngredients,
    isFormValid,
    isOpenMeasure,
    isOpenGroup,
    isOpenProcess,
    
    // Действия
    handleInputChange,
    handleSelect,
    handleChange,
    handleAdd,
    handleDelete,
    handleWeightChange,
    setHidden,
    handleFocusMeasure: () => setIsOpenMeasure(!isOpenMeasure),
    handleFocusGroup: () => setIsOpenGroup(!isOpenGroup),
    handleFocusProcess: () => setIsOpenProcess(!isOpenProcess),
    getIngredientsForServer
  };
};